import computed from './computed'
import methods from './methods'
import props from './props'

export default {
  computed,
  methods,
  props,

  resourcePath: 'v1/patient/scheduling/schedules/'
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/cancel/resources/index.js